import { Input, message, Modal, Select } from 'antd';
import axiosInstance from '../../../../axios/axiosInstance';
import { gameStatusList, gameTypeList } from '../../../../utils/enumMapper';
import { useEffect, useState } from 'react';
import { useMasterGradesSelector, useMasterSubjectsSelector } from '../../../../redux/selector';
import { ModePage } from 'common/enum';
import { useParams } from 'react-router-dom';
import processError from '../../../../utils/processError';
import { Book, Game } from 'model/response';


interface Props {
  isOpen: boolean;
  onCloseModal: () => void;
  modePage: ModePage;
  onSave: () => void;
  gameId: string;
}

export default function AddNewGame({ isOpen, onCloseModal, modePage, onSave, gameId }: Props) {
  const params = useParams();
  const [newGame, setGame] = useState<Game | null>(null);


  const onInputField = (e: any, fieldName: string) => {
    const newGameTemp = { ...newGame } as any;
    newGameTemp[fieldName] = e.target.value;

    setGame(newGameTemp);
  };

  const onChangeSelect = (e: any, fieldName: string) => {
    
    const newGameTemp = { ...newGame } as any;
    newGameTemp[fieldName] = e;
    setGame(newGameTemp);
    
  };


  const loadNewGame = async () => {
    try {
      const res = await axiosInstance({
        url: `/games`,
        method: 'get',
      });

      if (res.status === 200) {
        setGame(res.data);
      } else {
        message.error('Có lỗi xảy ra.');
      }
    } catch (err) {
      processError(err);
    }
  };

  const loadEditGame = async () => {
    try {
      const res = await axiosInstance({
        url: `/games/${gameId}`,
        method: 'get',
      });

      if (res.status === 200) {
        setGame(res.data);
      } else {
        message.error('Có lỗi xảy ra.');
      }
    } catch (err) {
      processError(err);
    }
  };

  const onOk = async () => {
    try {
      const res = await axiosInstance({
        url: '/games',
        method: modePage === ModePage.ADD ? 'post' : 'put',
        data: newGame,
      });

      if (res.status === 200 || 201) {
        message.success(modePage === ModePage.ADD ? 'Thêm thành công.' : 'Sửa thành công.');
        onSave();
      } else {
        message.error('Có lỗi xảy ra.');
      }
    } catch (err) {
      processError(err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      modePage === ModePage.ADD ? loadNewGame() : loadEditGame();
    }
    console.log(gameTypeList);
  }, [isOpen]);

 
  return (
    <Modal open={isOpen} onOk={onOk} onCancel={onCloseModal}>
      <div className="mt-8">
        <div className="flex items-center gap-2">
          <div className="w-[210px]">Tên trò chơi:</div>
          <Input maxLength={255} name="name" onChange={(e) => onInputField(e, 'name')} value={newGame?.name} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">Mã trò chơi:</div>
          <Input maxLength={255} name="code" onChange={(e) => onInputField(e, 'code')} value={newGame?.code} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[140px]">Loại trò chơi:</div>
          <Select
              onChange={(e) => onChangeSelect(e, 'type')}
              className="w-full"
              placeholder="Loại trò chơi"
              style={{ flex: 1 }}
              value={newGame?.type}
              options={gameTypeList.map((item: any) => ({
                value: item.value,
                label: item.label,
              }))}
            />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[140px]">Trạng thái:</div>
          <Select
              onChange={(e) => onChangeSelect(e, 'status')}
              className="w-full"
              placeholder="Trạng thái"
              style={{ flex: 1 }}
              value={newGame?.status}
              options={gameStatusList}
            />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">Thumbnails:</div>
          <Input maxLength={255} name="thumbnails" onChange={(e) => onInputField(e, 'thumbnails')} value={newGame?.thumbnails} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">URL:</div>
          <Input maxLength={255} name="url" onChange={(e) => onInputField(e, 'url')} value={newGame?.url} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">Mô tả:</div>
          <Input maxLength={500} name="description" onChange={(e) => onInputField(e, 'description')} value={newGame?.description} />
        </div>
        
      </div>
    </Modal>
  );
}
